import { render, staticRenderFns } from "./MilestoneEventItem.vue?vue&type=template&id=005696ca&scoped=true&"
import script from "./MilestoneEventItem.vue?vue&type=script&lang=js&"
export * from "./MilestoneEventItem.vue?vue&type=script&lang=js&"
import style0 from "./MilestoneEventItem.vue?vue&type=style&index=0&id=005696ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005696ca",
  null
  
)

export default component.exports